<template>
  <div id="app" v-bind:style="{ height: screeHeight + 'px' }">
    <div class="login-box" v-if="!shouForget">
      <p class="login-title">小程序后台系统登录</p>
      <input type="text" class="login-input" placeholder="请输入账号" v-model="loginForm.userName" minlength="6" name="user"
        maxlength="20" autocomplete="off" />
      <input type="password" style="padding: 0 15px; box-sizing: border-box" class="login-input" placeholder="请输入密码"
        autocomplete="off" v-model="loginForm.password" />
      <div class="codebox">
        <input type="text" class="login-input" style="width: 268px; margin: 0" placeholder="请输入验证码"
          v-model="loginForm.code" autocomplete="off" name="code" @keyup.enter="loginFn" />
        <div class="code">
          <img style="width: 100%; height: 100%" :src="codeUrl" alt="" @click="getCode" />
        </div>
      </div>
      <div class="codebox" style="margin-top: 56px; font-size: 16px">
        <el-checkbox v-model="checkedPassword" style="color: #2d46ee; font-size: 16px"
          @change="getChecked">记住密码</el-checkbox>
        <span style="cursor: pointer" @click="shouForget = true">忘记密码？</span>
      </div>
      <div class="login" @click="loginFn">登录</div>
    </div>
    <div class="login-box" style="padding: 32px 60px" v-else>
      <p class="login-title" style="margin-bottom: 32px">找回密码</p>
      <p class="tips">
        注意：【找回密码】只有超级管理员才可使用，普通管理员修改密码需要找超级管理员在系统中修改！
      </p>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="登录账号" prop="username">
          <el-input v-model="ruleForm.username" placeholder="请输入登录账号"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <template>
            <div style="display: flex">
              <div>
                <el-input v-model="ruleForm.code" placeholder="请输入验证码"></el-input>
              </div>
              <div class="get-code" v-if="!isCode" @click="getBackCode()">
                获取验证码
              </div>
              <div class="get-code1" v-if="isCode">
                {{ backTime }}秒后重新获取
              </div>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="ruleForm.password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <p class="ipt-tips">
          <span style="color: red">*</span>密码由英文、数字、符号组成，最少输入8位
        </p>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="ruleForm.confirmPassword" placeholder="请再次输入密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <!-- <div class="ipt-item">
        <p class="ipt-label"><span>*</span>登录账号</p>
        <input type="text" class="find-ipt" placeholder="请输入登录账号" />
      </div>
      <div class="ipt-item">
        <p class="ipt-label">手机号</p>
        <input type="text" class="find-ipt" placeholder="请输入绑定手机号" />
      </div>
      <div class="ipt-item">
        <p class="ipt-label">验证码</p>
        <input type="text" class="find-ipt" placeholder="请输入验证码" />
        <div class="get-code">获取验证码</div>
      </div>
      <div class="ipt-item">
        <p class="ipt-label">新密码</p>
        <input type="text" class="find-ipt" placeholder="请输入新密码" />
      </div>
      <div class="ipt-item" style="margin-top: 8px">
        <p class="ipt-label"></p>
        <p class="ipt-tips">
          <span style="color: red">*</span
          >密码由英文、数字、符号组成，最少输入6位
        </p>
      </div>
      <div class="ipt-item">
        <p class="ipt-label">确认密码</p>
        <input type="text" class="find-ipt" placeholder="请输入新密码" />
      </div> -->
      <div class="login" @click="submitB">确 认</div>
      <div style="margin-left: 199px; line-height: 60px; cursor: pointer" @click="shouForget = false">
        账号密码登录
      </div>
    </div>
    <!-- 备案 -->
    <div class="keep">
      <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备17071851号</a>&nbsp;<span>版权所有 © 广东九航商业发展有限公司</span>
    </div>
  </div>
</template>

<script>
import { getCookie } from '../../utils/index.js'
import { menu } from '../../../src/assets/josn/menu.js'
export default {
  data() {
    return {
      isCode: false,
      backTime: 60,
      ruleForm: {
        username: '',
        phone: '',
        code: '',
        password: '',
        confirmPassword: '',

      },
      rules: {
        username: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入手机号'))
              } else {
                const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/; //手机号正则表达式
                console.log(reg.test(value))
                if (reg.test(value)) {
                  callback()
                } else {
                  return callback(new Error('请输入正确的手机号'))
                }
              }
            },
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          // { min: 6, message: "密码最少输入6位", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              //是否包含数字
              var ptr_digit = /^.*[0-9]+.*$/;
              //是否包含小写字母
              var ptr_lowcase = /^.*[a-z]+.*$/;
              //是否包含大写字母
              var ptr_upcase = /^.*[A-Z]+.*$/;
              //是否包含特殊字符（非数字、字母的字符）
              var ptr_special = /((?=[\x21-\x7e]+)[^A-Za-z0-9])/;
              // var ptr_special = /^.*[~`!@#$%^&*()_+|<>,.?/:;'\\[\\]{}\"]+.*$/;

              if (value.length < 8) {
                callback(new Error('密码至少8位'));
              }
              else if ((ptr_digit.test(value) && ptr_lowcase.test(value) && ptr_upcase.test(value) && ptr_special.test(value))
                || (!ptr_digit.test(value) && ptr_lowcase.test(value) && ptr_upcase.test(value) && ptr_special.test(value))
                || (ptr_digit.test(value) && !ptr_lowcase.test(value) && ptr_upcase.test(value) && ptr_special.test(value))
                || (ptr_digit.test(value) && ptr_lowcase.test(value) && !ptr_upcase.test(value) && ptr_special.test(value))
                || (ptr_digit.test(value) && ptr_lowcase.test(value) && ptr_upcase.test(value) && !ptr_special.test(value))) {
                callback();
              }
              else {
                callback(new Error("至少包含大写字母、小写字母、数字、特殊字符中的三类字符"))
              }
            },
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.ruleForm.password) {
                return callback(new Error("两次密码不一样,请重新输入"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      time: 60000,
      isShow: false,
      loginForm: {
        userName: '',
        password: '',
        code: '',
        remember: 0
      },
      forgetPass: {
        username: '',
        password: ''
      },
      screeHeight: 600,

      count: '', // 倒计时
      show: false,
      codeUrl: '',
      shouForget: false,
      checkedPassword: false
    }
  },
  watch: {
    loginForm: {
      deep: true,
      handler(newVal, oldVal) {
        // if (newVal.username !== '' || newVal.password !== '') {
        //   this.btnStyle = true
        // } else {
        //   this.btnStyle = false
        // }
        this.loginForm.userName = this.loginForm.userName.replace(/[\u4e00-\u9fa5]/ig, '')
      }
    },
    active: {
      handler(newVal, oldVal) {
        if (newVal == 2) {
          this.btnContent = '我知道了，进入五域系统'
        }
      }
    }
  },
  created() {
    // let first = localStorage.getItem("first")
    // if (first) {
    //   this.versionsDialogVisible = false
    // } else {
    //   this.versionsDialogVisible = true
    //   this.threeGo()
    // }

    // this.systemAxios();
    let account = localStorage.getItem('account') || null;
    if (account) {
      account = JSON.parse(account)
      this.loginForm = Object.assign(this.loginForm, account)
      if (this.loginForm.remember == 1) {
        this.checkedPassword = true
      }
      console.log(this.loginForm)
    }
    this.getCode()
    // this.getDictionaries('win_global_type')

    if (this.$route.query.type === 0) {
      this.$message.error('token已过期请重新登录')
    }

    var h = document.documentElement.clientHeight || document.body.clientHeight
    this.screeHeight = h // 减去页面上固定高度height

    window.onresize = () => {
      var h =
        document.documentElement.clientHeight || document.body.clientHeight
      this.screeHeight = h // 减去页面上固定高度height
    }
    // this.broadcast()
  },
  updated() {
    var h = document.documentElement.clientHeight || document.body.clientHeight
    this.screeHeight = h // 减去页面上固定高度height
  },
  mounted() {
    if (this.getCookieValue('checked') == 'true') {
      // this.getcookie()
    }
  },
  methods: {
    submitB() {
      this.$refs.ruleForm.validate((result) => {
        if (result) {
          this.axios.post('/sys/updatePassword', this.ruleForm).then(res => {
            if (res.code == 0) {
              this.$message.success('找回成功，请登录')
              this.shouForget = false
            }
          })

        }
      });
    },

    getChecked(e) {
      if (e) {
        let data = {
          userName: this.loginForm.userName,
          password: this.loginForm.password,
          remember: 1
        }
        localStorage.setItem('account', JSON.stringify(data))
      } else {
        localStorage.removeItem('account')
      }

    },
    //找回密码，获取验证码
    getBackCode() {
      if (this.ruleForm.username == '' || this.ruleForm.phone == '') {
        this.$refs.ruleForm.validateField("username")
        this.$refs.ruleForm.validateField("phone")
        return
      }
      let data = {
        phone: this.ruleForm.phone,
        username: this.ruleForm.username
      }
      this.axios.get('/sys/getPhoneCode', { params: data }).then(res => {
        if (res.code == 0) {
          this.$message.success('获取成功')
          this.isCode = true
          let time = setInterval(() => {
            if (this.backTime > 0 && this.backTime <= 60) {
              this.backTime--
            } else {
              this.isCode = false
              clearInterval(time)
              time = null
            }
          }, 1000)
        }
      })
    },
    //获取验证码
    async getCode() {

      this.codeUrl = process.env.VUE_APP_API_BASE_URL + '/sys/getLoginCode?v=' + Math.random();
      console.log(this.codeUrl)
    },
    // 上一步
    back() {
      this.active--
      this.count = 0
    },
    // 倒计时三秒
    threeGo() {
      const TIME_COUNT = 3
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },



    finish() {
      this.isShow = false
      if (this.$refs.countDown) {
        this.$refs.countDown.reset()
      }
    },
    start() {
      this.isShow = true
      this.$nextTick(function () {
        this.$refs.countDown.start()
      })
    },
    pause() {
      this.$refs.countDown.pause()
    },
    //登录接口
    loginFn() {
      let data = this.loginForm;
      data.remember = this.checkedPassword ? 1 : 0;
      if (data.userName == '') {
        this.$message.warning('请输入账号')
        return
      }
      if (data.userName.length < 6) {
        this.$message.warning('请输入至少6位账号')
        return
      }
      if (data.password == '') {
        this.$message.warning('请输入密码')
        return
      }
      if (data.code == '') {
        this.$message.warning('请输入验证码')
        return
      }
      if (data.remember == 1) {
        let data1 = {
          userName: this.loginForm.userName,
          password: this.loginForm.password,
          remember: 1
        }
        localStorage.setItem('account', JSON.stringify(data1))
      }

      this.axios.post('/sys/login', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$store.commit('token', res.data.token)
            let userName = res.data.roleName + ' ' + res.data.username
            sessionStorage.setItem('userName', JSON.stringify(userName))
            sessionStorage.setItem('platformType', res.data.platformType)
            this.getMenus()
            this.getUserInfo()
          }
          // this.getCode()
        })
    },
    getUserInfo() {
      this.axios.post('/sys/getUserInfo')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            sessionStorage.setItem('userInfo', JSON.stringify(res.data))
          }
        })
    },
    //获取菜单列表接口
    getMenus() {
      this.axios.get('/sys/menus')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            let iconList = [
              'icon_yonghuguanli@2x',
              'icon_shanpin@2x',
              'icon_dingdan@2x',
              'icon_caiwu@2x',
              'icon_xitong@2x',
              'icon_shangcheng@2x',
              'icon_yingxiao@2x'
            ]
            // res.data.splice(res.data.length-1,1)
            res.data.forEach((item, index) => {
              item.iconUrl = iconList[index]
            })
            this.limits(res.data)
          }

        })
    },

    // 登录接口
    login(e) {
      this.axios
        .post(
          '/auth/oauth/token?client_id=web&grant_type=password&scope=server&client_secret=123456&password=' +
          this.loginForm.password +
          '&username=' +
          encodeURI(this.loginForm.username),
          {
            headers: {
              Authorization: '',
              isLoading: false
            }
          }
        )
        .then((res) => {
          this.$store.commit('token', res.access_token)
          const userId = res.user_id
          this.axios.get(`/sys/v1/user/employee/get/roleNames?employeeId=${userId}`).then((res) => {
            sessionStorage.setItem('role', res.data)
          })

          if (!this.is_null(res.code)) {
            this.$message({ type: 'warning', message: res.message })
          } else {
            this.$store.commit('token', res.access_token)
            this.getToken(res.access_token, e)
          }
        })
    },
    // 获取token
    getToken(n, e) {
      this.axios
        .get('/sys/v1/user/getInfo?winType=' + this.loginForm.system, {
          headers: {
            isLoading: false
          }
        })
        .then((res) => {
          console.log(res)
          //   if (e == 1 && res) {//e == 1 ---表示登录并绑定旧账号按钮
          //   this.setPasswordDialogVisible = true;
          // }
          if (res.data.dingId == '' && res.data.userType !== '1') {
            this.$message.warning('请使用钉钉账号登录系统！')
            return false
          } else if (e == 1 && res) {
            this.setPasswordDialogVisible = true
            return false
          }

          if (res.data.flag == 0 && e == 2) { // firstLogin=（1--钉钉首次登录）（0--不是钉钉首次登录） e == 1 登录并绑定  e==2 登录按钮
            // this.firstDialogVisible = true
            return false
          }
          if (res.code == 0) {
            this.$store.commit('user_id', res.data.id)
            let array = ''
            if (this.is_null(res.data.salesAuthorityId)) {
              array = ''
            } else {
              array = res.data.salesAuthorityId
            }
            this.$store.commit('salesAuthorityId', array)
            const sess = {
              parentOrgName: res.data.parentOrgName,
              orgName: res.data.orgName,
              reallyName: res.data.reallyName,
              positionName: res.data.positionName,
              img: res.data.avatarUrl
            }
            sessionStorage.setItem('personInfo', JSON.stringify(sess))
            sessionStorage.setItem('positionCode', res.data.positionCode)
            sessionStorage.setItem('orgCode', res.data.orgCode)
            sessionStorage.setItem(
              'orgCodes',
              JSON.stringify(res.data.orgCodes)
            )
            sessionStorage.setItem('userInfo', JSON.stringify(res.data))
            // this.$message({ type: "success", message: "登录成功" });
            this.limits()
          } else {
            this.$message({ type: 'warning', message: res.message })
          }
        })
    },
    // 登录接口
    getcookie() {
      var arr = document.cookie.split('; ')
      if (document.cookie.length > 0) {
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') // 再次切割
          // 判断查找相对应的值
          if (arr2[0] == 'userName') {
            this.loginForm.username = arr2[1] // 保存到保存数据的地方
          } else if (arr2[0] == 'password') {
            this.loginForm.password = arr2[1]
          }
        }
        this.checked = true
        if (!this.$route.query.type) {
          this.submit('loginForm')
        }
      }
    },
    getCookieValue(c_name) {
      let c_start, c_end
      if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + '=')
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1
          c_end = document.cookie.indexOf(';', c_start)
          if (c_end == -1) c_end = document.cookie.length
          return unescape(document.cookie.substring(c_start, c_end))
        }
      }
      return ''
    },
    forgerEvent() {
      this.clearCookie()
      this.forget = false
    },
    // 清除cookie
    clearCookie: function () {
      this.setCookie('', '', -1) // 修改2值都为空，天数为负1天就好了
    },
    // 取消clance
    clance() {
      this.isShow = false
      if (this.$refs.countDown) {
        this.$refs.countDown.reset()
      }
      this.forget = true
    },
    // 设置cookie
    setCookie(c_name, c_pwd, c_ckd, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie =
        'userName' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie =
        'password' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie =
        'checked' + '=' + c_ckd + ';path=/;expires=' + exdate.toGMTString()
    },
    // 权限处理
    limits(menu) {
      let data = {
        menuTreeList: menu
      }
      sessionStorage.setItem('limit', JSON.stringify(data))
      this.$router.replace('home/welcome')
      // this.axios
      //   .get('/sys/v1/menu/button/user/tree?winType=' + this.loginForm.system, {
      //     headers: {
      //       isLoading: false
      //     }
      //   })
      //   .then((res) => {
      //     if (res.code == 0) {
      //       sessionStorage.setItem('limit', JSON.stringify(res.data))
      //       if (res.data.menuTreeList) {
      //         console.log(res)
      //         const juade = res.data.menuTreeList.find(
      //           (res) => res.code == 'index'
      //         )
      //         if (this.loginForm.system == '2') {
      //           this.$router.replace('dashboard')
      //         } else {
      //           console.log(juade, 'juade')
      //           if (juade) {
      //             // this.$router.replace('home')
      //             this.$router.replace('home/welcome') // 如果没有配置菜单权限就跳到欢迎页面
      //           } else {
      //             if (res.data.menuTreeList[0].children) {
      //               this.$router.replace(res.data.menuTreeList[0].children[0].jumpUrl)
      //             } else {
      //               this.$router.replace(res.data.menuTreeList[0].jumpUrl)
      //             }
      //           }
      //         }
      //       } else {
      //         this.$message({ type: 'warning', message: res.message })
      //       }
      //     } else {
      //       if (res.code == 103) {
      //         this.$router.replace('home/welcome') // 如果没有配置菜单权限就跳到欢迎页面
      //       }
      //       // this.$message({ type: "warning", message: res.message });
      //     }
      //   })
    },
    is_null(content) {
      if (content) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped lang="scss">
input[type="text"],
input[type="number"] {
  -webkit-appearance: none;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d8dce5;
  box-sizing: border-box;
  color: #5a5e66;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 1;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;

  &:hover {
    border-color: #b4bccc;
  }

  &:focus {
    border-color: #409EFF;
    outline: 0;
  }
}

::v-deep .el-input__inner {
  height: 48px;
}

#app {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../../assets/bg999.png");
}

.login-box {
  width: 598px;
  height: 676px;
  background: rgba(255, 255, 255, 0.7);
  border: 2px solid #ffffff;
  box-shadow: 0px 3px 32px rgba(45, 70, 238, 0.1);

  border-radius: 9px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(0, -50%);
  padding: 80px 60px;
  box-sizing: border-box;
  color: #2d46ee;

  .login-title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 56px;
  }

  .login-input {
    width: 100%;
    height: 64px;
    background: #ffffff;
    border: 1px solid #c0c0cc;
    border-radius: 3px;
    margin-bottom: 32px;
    outline: none;
    font-size: 16px;
  }

  .codebox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .code {
      flex: 1;
      margin-left: 12px;
      height: 64px;
      background-color: #ccc;
    }
  }

  .login {
    width: 478px;
    height: 72px;
    border-radius: 3px;
    font-size: 26px;
    color: white;
    text-align: center;
    line-height: 72px;
    margin-top: 24px;
    background: linear-gradient(133deg, #2182FF 0%, #2D46EE 100%);
    cursor: pointer;
  }
}

.tips {
  font-size: 14px;
  color: #f63c56;
  margin-bottom: 18px;
}

.ipt-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: #303033;
  margin-top: 18px;
}

.ipt-label {
  width: 80px;
  text-align: right;

  span {
    color: red;
  }
}

.find-ipt {
  border: 1px solid #c0c0cc;
  border-radius: 3px;
  height: 48px;
  flex: 1;
  margin-left: 18px;
}

.ipt-tips {
  flex: 1;
  font-size: 14px;
  color: #909099;
  margin-left: 100px;
  margin-bottom: 10px;
}

.get-code {
  width: 192px;
  height: 48px;
  background: #ff9226;
  border-radius: 3px;
  margin-left: 12px;
  font-size: 16px;
  color: white;
  text-align: center;
  line-height: 48px;
  cursor: pointer;
}

.get-code1 {
  width: 192px;
  height: 48px;
  background: #e5edf5;
  border-radius: 3px;
  margin-left: 12px;
  font-size: 16px;
  color: #999999;
  text-align: center;
  line-height: 48px;
}

/deep/.el-checkbox__label {
  font-size: 16px !important;
}

/deep/.el-checkbox__inner {
  width: 16px;
  height: 16px;
}

/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #2d46ee;
}

/deep/.el-checkbox__inner::after {
  left: 5px;
  top: 2px;
}

/deep/ .el-form-item__label {
  font-size: 16px;
  color: #303033;
}

.keep {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: #999;
  font-size: 14px;
  text-decoration: none;

  a {
    color: #999;
    font-size: 14px;
    text-decoration: none;
  }
}
</style>
